import React, { useState } from "react";
import clsx from "clsx";

import { AppBar, Toolbar, Typography, IconButton, Badge, Box, Avatar, Breadcrumbs, Link } from "@material-ui/core";
import Logo from "../../assets/images/MyProject_logo.svg";
import NotificationsIcon from "@material-ui/icons/Notifications";
import UserPopoverDetails from "./../user-popover-details";
import NotificationFlag from "../notification-flag";
import NotificationServicesManager from "../notification-services-manager";
import ToolTip from "components/common/black-tooltip";

export default ({ open, onLogoClick, ToggleSidebar, userAvatar, classes, notifications, notificationServices, handleSwitchChange, currentProject, navigateTo, ...props }) => {
	const [anchorElement, setAnchorElement] = useState(null);

	return (
		<AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
			<Toolbar>
				<img id="my-tasks-page" src={Logo} alt={"Oprex"} onClick={() => onLogoClick()} className={classes.logo} />
				<div style={{ flexGrow: 1 }}>
					{currentProject && (
						<Breadcrumbs separator={<span className={classes.separator}>/</span>}>
							{currentProject.parent && (
								<ToolTip
									title={currentProject.parent.name}
									component={
										<Link underline="hover" color="inherit" onClick={() => navigateTo(currentProject.parent.id)}>
											<Typography variant="h6" color="inherit" noWrap className={classes.title}>
												{`${currentProject.parent.number}`}
											</Typography>
										</Link>
									}
								/>
							)}
							<Typography variant="h6" color="inherit" noWrap className={classes.title}>
								{`${currentProject.number} -  ${currentProject.name}`}
							</Typography>
						</Breadcrumbs>
					)}
				</div>

				{/* <NotificationFlag notifications = {notifications} /> */}

				<NotificationServicesManager classes={classes} notificationServices={notificationServices} handleSwitchChange={handleSwitchChange} />
				<Box
					id="avatar-box"
					m={1}
					onClick={event => {
						setAnchorElement(prev => {
							return prev === null ? event.currentTarget : null;
						});
					}}>
					<Avatar id="avatar" alt="Stock avatar" src={userAvatar} />
					<UserPopoverDetails isOpen={Boolean(anchorElement)} anchorElement={anchorElement} {...props} />
				</Box>
			</Toolbar>
		</AppBar>
	);

};
